import { useMemo } from 'react'
import { useCountryContext } from '@/contexts/CountryContext'

const usePageType = () => {
  const { countryList } = useCountryContext()

  const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
  const fullPath = typeof window !== 'undefined' ? window.location.origin + pathname : null

  const pathSegments = useMemo(() => pathname.split('/').filter(Boolean), [pathname])

  const countryCodes = useMemo(() => countryList.map(c => c.countryGroup.toLowerCase()), [countryList])

  const initialPathname = pathSegments[0]?.toLowerCase()

  const isPageGlobal = useMemo(() => {
    return !countryCodes.includes(initialPathname)
  }, [initialPathname, countryCodes])

  const relevantSegments = isPageGlobal ? pathSegments : pathSegments.slice(1)

  const currentPageType = useMemo((): 'course_page' | 'class_page' | '' => {
    if (relevantSegments.length === 0) return ''

    if (relevantSegments.length === 1) {
      return 'course_page'
    }

    const secondSegment = relevantSegments[1]?.toLowerCase()

    // Match any segment like "something-1", "xyz-5", etc.
    const isPrefixNumberPattern = /^[a-zA-Z]+-\d+$/.test(secondSegment)

    if (relevantSegments.length === 2 && isPrefixNumberPattern) {
      return 'class_page'
    }

    return ''
  }, [relevantSegments])

  return { currentPageType, fullPath }
}

export default usePageType
